<form [formGroup]="formGroup" class="form-leaflet-create">
  <div class="nombre-parcela">
    <label class="input-label">Nombre de la parcela</label>
    <span class="nombre-parcela-nota"
      >El nombre de la parcela debe ser único dentro de la Comunidad de
      Regantes.</span
    >
    <app-input-field-material
      placeholder="Escribe un nombre para tu parcela"
      [errorInput]="nombreParcela.hasError('required') ? 'Obligatorio' : ''"
      [formControl]="nombreParcela"></app-input-field-material>
  </div>

  <app-input-field-material
    label="Referencia catastral"
    placeholder="Ej. 46251A01000545"
    [errorInput]="referenciaCatastral.hasError('required') ? 'Obligatorio' : ''"
    [formControl]="referenciaCatastral"></app-input-field-material>

  <app-chip
    backgrounColor="neutral"
    color="textNeutral"
    text="Una vez creada la parcela podrás completar el detalle, 
    editarla o elimanarla desde el Módulo de Gestión.">
  </app-chip>
</form>
